<style lang="scss" scoped>
@media screen and (max-width: 740px) {
  .mobile-header {
    margin-bottom: 0;
  }
  .employees-form {
    margin-top: 30px !important;
  }
  .save-info {
    width: 100%;
  }
  .cancel-employee {
    width: 100%;
    margin-top: 5px;
  }
  .approval-sabbatical {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .row-mobile {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .col-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .table {
    width: 550px;
  }
}
.approval-sabbatical {
  .col-md-10.offset-md-2 {
    margin: auto;
  }

  td.comment {
    max-width: 300px;
    word-wrap: break-word;
  }

  .save-info {
    background: #b4daf3;
    font-weight: 600;
    padding: 7px 70px;
    color: #0d2e48;
    margin-right: 20px;
    border: 2px solid #b4daf3;
  }

  label {
    font-weight: 600;
  }

  .input-group {
    margin-bottom: 0px !important;
  }

  .cancel-employee {
    padding: 7px 45px;
    font-weight: 600;
    background: #f6f6f6;
    border: 2px solid #0d2e48;
    color: #0d2e48;
  }

  span.require {
    color: #ff1a1a;
  }

  span.required {
    color: #ff1a1a;
    margin-top: -15px;
  }

  .submit-form {
    margin-top: 30px;
    text-align: center;
  }
}
</style>

<template>
  <CContainer class="approval-sabbatical">
    <CRow class="row-mobile">
      <CCol :md="{ size: '10', offset: '2' }" class="col-mobile">
        <CCard>
          <CCardHeader>
            <label class="mobile-header">{{ $t("sabbatical.label_title_approval") }}</label>
          </CCardHeader>
          <CCardBody>
            <div class="create_form">
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("commons.label_employee_send") }}
                  </label>
                  <CInput
                    :disabled="true"
                    :value="
                      employeeSabbaticalRequest.employee
                        ? employeeSabbaticalRequest.employee.name
                        : ''
                    "
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("employee.label_employee_foot") }}
                  </label>
                  <CInput
                    :disabled="true"
                    v-model="employeeSabbaticalRequest.foot"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("employee.label_employee_division") }}
                  </label>
                  <CInput
                    :disabled="true"
                    v-model="employeeSabbaticalRequest.division"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("commons.label_created_at") }}
                  </label>
                  <CInput
                    :disabled="true"
                    v-model="employeeSabbaticalRequest.created_at"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("employee.label_employee_date_start") }}
                  </label>
                  <CInput
                    :disabled="true"
                    v-model="employeeSabbaticalRequest.start_date"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("overtime.end_time") }}
                  </label>
                  <CInput
                    :disabled="true"
                    v-model="employeeSabbaticalRequest.end_date"
                  />
                </CCol>
              </CRow>
              <CRow v-if="employeeSabbaticalRequest.reason_type != 4">
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("sabbatical.number_days_off") }}
                  </label>
                  <CInput
                    :disabled="true"
                    v-model="employeeSabbaticalRequest.number_days_off"
                  />
                </CCol>
              </CRow>
              <!-- Physiological leave -->
              <CRow v-else>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("sabbatical.number_minutes_off") }}
                  </label>
                  <CInput
                    :disabled="true"
                    :value="Math.round(employeeSabbaticalRequest.number_days_off * 8 * 60)"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("commons.status") }}
                  </label>
                  <CInput
                    :disabled="true"
                    :value="
                      $t(
                        'overtime.employee_approval_' +
                          employeeSabbaticalRequest.status
                      )
                    "
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("commons.label_reason") }}
                  </label>
                  <CInput
                    :disabled="true"
                    :value="
                      employeeSabbaticalRequest.sabbatical_leave_reason
                        ? employeeSabbaticalRequest.sabbatical_leave_reason
                            .reason
                        : ''
                    "
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("sabbatical.type_reason") }}
                  </label>
                  <CInput
                    :disabled="true"
                    :value="
                      $t(
                        'sabbatical.type_reason_' +
                          employeeSabbaticalRequest.reason_type
                      )
                    "
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("sabbatical.note") }}
                  </label>
                  <b-form-textarea
                    id="textarea"
                    rows="4"
                    max-rows="6"
                    :disabled="true"
                    v-model="employeeSabbaticalRequest.note"
                  ></b-form-textarea>
                </CCol>
              </CRow>
              <!-- Sabbatical approval list-->
              <CRow class="mt-4">
                <CCol md="12" sm="12" class="employees-form approval-ot">
                  <div class="text-label">
                    <div class="text-center">
                      <h4 class="title-header">
                        {{ $t("overtime.information_approval_ot") }}
                      </h4>
                    </div>
                  </div>
                  <div class="text-label-content">
                    <div class="table-responsive table-employee-note">
                      <table class="table">
                        <thead>
                          <tr>
                            <th class="index">#</th>
                            <th class="text-center create-by">
                              {{ $t("overtime.employee_approval") }}
                            </th>
                            <th class="text-center create-at">
                              {{ $t("overtime.employee_approval_status") }}
                            </th>
                            <th class="text-center">
                              {{ $t("overtime.employee_approval_note") }}
                            </th>
                            <th class="text-center">
                              {{ $t("overtime.employee_approval_time") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <template
                            v-if="
                              employeeSabbaticalRequest &&
                                employeeSabbaticalRequest.sabbatical_leave_approves &&
                                employeeSabbaticalRequest
                                  .sabbatical_leave_approves[0] &&
                                employeeSabbaticalRequest
                                  .sabbatical_leave_approves[1] &&
                                employeeSabbaticalRequest
                                  .sabbatical_leave_approves[0].employee_id ===
                                  employeeSabbaticalRequest
                                    .sabbatical_leave_approves[1].employee_id
                            "
                          >
                            <tr>
                              <th scope="row index">1</th>
                              <td class="text-center">
                                {{
                                  employeeSabbaticalRequest
                                    .sabbatical_leave_approves[0].employees[0]
                                    .name
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  $t(
                                    `overtime.employee_approval_${employeeSabbaticalRequest.sabbatical_leave_approves[0].status}`
                                  )
                                }}
                              </td>
                              <td class="comment text-center">
                                {{
                                  employeeSabbaticalRequest
                                    .sabbatical_leave_approves[0].comment
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  employeeSabbaticalRequest
                                    .sabbatical_leave_approves[0].updated_at
                                    | formatDateTime
                                }}
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr
                              v-for="(item,
                              index) in employeeSabbaticalRequest.sabbatical_leave_approves"
                              :key="index"
                            >
                              <th scope="row index" class="text-center">{{ index + 1 }}</th>
                              <td class="text-center">{{ item.employees[0].name }}</td>
                              <td class="text-center">
                                {{
                                  $t(
                                    `overtime.employee_approval_${item.status}`
                                  )
                                }}
                              </td>
                              <td class="comment text-center">{{ item.comment }}</td>
                              <td class="text-center">{{ item.updated_at | formatDateTime }}</td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <div
                v-if="
                  employeeSabbaticalRequest &&
                    myApproveInfo &&
                    employeeSabbaticalRequest.status === 1 &&
                    myApproveInfo.status === 1
                "
              >
                <ValidationObserver ref="form">
                  <CRow>
                    <CCol md="12" class="form-field">
                      <label>
                        {{ $t("commons.note") }}
                      </label>
                      <ValidationProvider
                        rules="max:512"
                        v-slot="{ errors }"
                        name="overtime.note"
                      >
                        <b-form-textarea
                          rows="3"
                          max-rows="6"
                          v-model="forms.comment"
                        />
                        <span v-if="!error" class="error image required">
                          {{ errorMessage }}
                        </span>
                        <span class="required">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </CCol>
                    <CCol md="12" class="employees-form mt-3 text-center" v-if="employeeSabbaticalRequest.editable">
                      <CButton
                        type="button"
                        class="save-info"
                        @click="showPopupApprove()"
                      >
                        {{ $t("commons.approve") }}
                      </CButton>
                      <CButton
                        class="cancel-employee"
                        type="button"
                        @click="showPopupCancel()"
                      >
                        <span v-if = "pmWaitingForApproval">
                          {{ $t("commons.admin_unapprove") }}
                        </span>
                        <span v-else>
                          {{ $t("commons.cancel_approve") }}
                        </span>
                      </CButton>
                    </CCol>
                  </CRow>
                </ValidationObserver>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_request_approval"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  computed: {
    ...mapGetters({
      employeeSabbaticalRequest:
        "sabbatical-leave-request/employeeSabbaticalRequest",
      flagNotification: "commons/flagNotification",
      account: "auth/account",
    }),
    levelAccountApprove() {
      let data = this.employeeSabbaticalRequest.sabbatical_leave_approves.filter((element) => {
        return element.employee_id == this.account.id;
      });

      return data[0];
    },
    pmWaitingForApproval()
    {
      return  this.employeeSabbaticalRequest.sabbatical_leave_approves[0] && 
      this.employeeSabbaticalRequest.sabbatical_leave_approves[0].level == 1 && 
      this.employeeSabbaticalRequest.sabbatical_leave_approves[0].status == 1 && 
      this.employeeSabbaticalRequest.sabbatical_leave_approves[1]; 
    }
  },
  data() {
    return {
      forms: {
        status: 1,
        comment: ""
      },
      error: true,
      errorMessage: "",
      myApproveInfo: {}
    };
  },

  methods: {
    ...mapMutations("commons", ["setNotificationFlag"]),

    async submitSabbaticalRequest() {
      if (this.forms.status === 3) {
        if (this.forms.comment === "") {
          this.error = false;
          this.errorMessage = this.$t(
            "error.validation.approve_person_comment.required"
          );
          return false;
        }
      }
      this.$root.$loading.start();
      await this.$store
        .dispatch("sabbatical-leave-request/approvalSabbatical", {
          data: this.forms,
          id: this.$route.params.id
        })
        .then(() => {
          let message = this.$t("overtime.message_approval_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: "/sabbatical-leave-request" });
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    async getInfoApproval() {
      if (this.$route.params.id) {
        this.$root.$loading.start();
        await this.$store.dispatch(
          "sabbatical-leave-request/showEmployeeSabbaticalRequest",
          this.$route.params.id
        );
        const account = this.$store.getters["auth/account"];
        if (this.employeeSabbaticalRequest.sabbatical_leave_approves) {
          this.myApproveInfo = this.employeeSabbaticalRequest.sabbatical_leave_approves.filter(
            f => f.employee_id === account.id
          )[0];
        }
        this.$root.$loading.finish();
        this.setNotificationFlag(false);
      }
    },

    showPopupApprove() {
      this.$confirmModal(
        this.$t("popup.sabbatical.label_popup_title_approve"),
        this.$t("popup.sabbatical.label_popup_approve_title"),
        this.$t("popup.sabbatical.label_confirm_button_approve"),
        this.$t("popup.sabbatical.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.forms.status = 2;
          this.submitSabbaticalRequest();
        }
      });
    },

    async showPopupCancel() { 
      if ((this.employeeSabbaticalRequest.sabbatical_leave_approves[0] && 
        this.employeeSabbaticalRequest.sabbatical_leave_approves[0].level == 1 && 
        this.employeeSabbaticalRequest.sabbatical_leave_approves[0].status != 1 ) || !this.employeeSabbaticalRequest.sabbatical_leave_approves[1]){
          this.$confirmModal(
            this.$t("popup.sabbatical.label_popup_title_sabbatical_cancel"),
            this.$t("popup.sabbatical.label_popup_approve_title"),
            this.$t("popup.sabbatical.label_confirm_button_approve"),
            this.$t("popup.sabbatical.label_cancel_button"),
            "danger"
          ).then(value => {
            if (value) {
              this.forms.status = 3;
              this.submitSabbaticalRequest();
            }
          });
        }
      else{
        this.$confirmModal(
            this.$t("popup.sabbatical.label_popup_content_offer"),
            this.$t("popup.sabbatical.label_popup_title_offer"),
            this.$t("popup.commons.label_popup_title_cancel_approve"),
            this.$t("popup.commons.label_cancel_button"),
            "danger"
          ).then(value => {
            if (value) {
              this.forms.status = 5;
              this.submitSabbaticalRequest();
            }
        });
      }
    }
  },

  async created() {
    await this.getInfoApproval();
  },

  watch: {
    async flagNotification(value) {
      if (value) {
        this.myApproveInfo = {};
        await this.getInfoApproval();
      }
    }
  }
};
</script>
